import { Inject, Injectable } from '@angular/core';

import { Meta, Title } from '@angular/platform-browser';

import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { SpotterEnvironment } from '@spotter/environments/environment.template';
import { SPOTTER_ENV } from '@spotter/tokens/env.token';
//import { navigationCancelingError } from '@angular/router/src/shared';

@Injectable({ providedIn: 'root' })
export class SEOService {



    constructor(
        private title: Title,
        private meta: Meta,
        private router: Router,
        @Inject(SPOTTER_ENV) private env: SpotterEnvironment,
    ) {
        this.resetMeta();
        this.router.events.subscribe(
            event => {
                if (event instanceof NavigationStart)
                    this.resetMeta();
                if (event instanceof NavigationEnd)
                    this.meta.updateTag({ property: 'og:url', content: document.location.href });
            }
        )
    };

    resetMeta() {
        this.setTitle(undefined);
        this.setDescription(undefined);
        this.setImage(undefined);
        this.setType('article');
        this.meta.updateTag({ name: 'twitter:card', content: 'summary_large_image' });
    }

    setTitle(title?: string) {
        let pageTitle;
        const siteName = this.env.siteName;
        if (title)
            pageTitle = `${title} - ${siteName}`;
        else
            pageTitle = siteName;

        this.title.setTitle(pageTitle);
        this.meta.updateTag({ property: 'og:title', content: pageTitle });
        this.meta.updateTag({ name: 'twitter:title', content: pageTitle });
        // console.log(this.meta);

    }

    setDescription(description?: string) {
        if (!description)
        {
            if (this.env.siteName === "SeagrassSpotter")
                this.setDescription('A global tool for people to help locate seagrass');
            else if (this.env.siteName === "SeagrassTracker")
                this.setDescription('A tool for tracking seagrass coverage');
            else if (this.env.siteName === "SeagrassRestorer")
                this.setDescription('A tool for knowledge sharing on seagrass restoration');
            return;
        }

        this.meta.updateTag({ property: 'og:description', content: description });
        this.meta.updateTag({ name: 'twitter:description', content: description });
    }

    setType(type: string) {
        this.meta.updateTag({ property: 'og:type', content: type });
    }

    setImage(image?: string) {

        if (!image)
        {
            this.meta.removeTag("property='og:image:width'");
            this.meta.removeTag("property='og:image:height'");

            if (this.env.siteName === "SeagrassSpotter")
                this.setImage('https://seagrassspotter.org/assets/socials/spottersocial.jpg');
            else if (this.env.siteName === "SeagrassTracker")
                this.setImage('https://seagrasstracker.org/assets/socials/trackersocial.png');
            else if (this.env.siteName === "SeagrassRestorer")
                this.setImage('https://seagrassrestorer.org/assets/socials/restorersocial.png');

            return;
        }

        // Only load the image size if we are prerendering
        const isPrerender = typeof window !== 'undefined' && (window as any).__SPOTTER_PRERENDER__ === true;
        if (isPrerender)
        {
            const img = new Image();
            img.onload = () => {
                this.meta.updateTag({ property: 'og:image:width', content: String(img.naturalWidth) });
                this.meta.updateTag({ property: 'og:image:height', content: String(img.naturalHeight) });
            };
            img.src = image;
        }


        console.log(image);



        this.meta.updateTag({ property: 'og:image', content: image });
        this.meta.updateTag({ name: 'twitter:image', content: image });
    }



}
